$(document).ready( function() {
  //text box change trigger
  $('input[type=text]', '.careerSearchControls').on('change paste keyup', function() {
    filterCareers();
  });
  
  //search button trigger
  $('.careerSearchSubmit').on('click', function() {
    filterCareers();
  });
  
  //drop down trigger
  $('.careerBlock .careerSearchControls select').on('change', function() {
    filterCareers();
  });
});

function filterCareers() {

  //var member = $('.career_memberFilter').val();
  //var position = $('.positionFilterText').val();
  //var location = $('.locationFilterText').val();

  $('.career-listing-grid div.careerList').each(function(index, element) {
    
    if ($('.career_memberFilter').val() != '' && $(element).find('.listing_company').html() != $('.career_memberFilter').val()) {

      $(element).hide();

    } else if ($('.career_positionFilter').val() != '' && $(element).find('.listing_position').html() != $('.career_positionFilter').val()) {

        $(element).hide();

    } else if ($('.career_locationFilter').val() != '' && $(element).find('.listing_location').html() != $('.career_locationFilter').val()) {

      $(element).hide();

    } else if ($('.career_shiftFilter').val() != '' && $(element).find('.listing_shift').html() != $('.career_shiftFilter').val()) {

      $(element).hide();

    } else {

      $(element).show();

    }

    //  check for no results
    if ($('.career-listing-grid div.careerList:visible').length == 0)
    {
      $('.career-listing-grid div.empty').show();
    }
    else
    {
      $('.career-listing-grid div.empty').hide();
    }
    
    //after fitlers have been completed set backgrounds to correct color pattern
    setCareerTableBgColors();

  });
}

function setCareerTableBgColors() {
  $('.career-listing-grid .careerList:visible:even').css('background','#fff');
  $('.career-listing-grid .careerList:visible:odd').css('background','#eaeaea');
}


// WEBPACK FOOTER //
// ./scripts/careers.js